import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Switch, NumberInput, Input } from '@mantine/core'
import { useLimitationForm } from './schema/form'
import { updateMembership } from '../../../../services/users'
import { notificationError, notificationSuccess } from '../../../ui/Notifications'


const FormAdjustMembership = ({ dataMembership, onCloseForm, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)

  const form = useLimitationForm()

  const submitLimitation = async (form) => {

    setLoadingForm(true)
    try {
      const response = await updateMembership(dataMembership.id, form)
      if (response.success) {
        notificationSuccess("Update Limitation Success", "Limitation has been updated successfully")
        setLoadingForm(false)
        reloadList()
        onCloseForm()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError("Update Limitation Failed", errorMessage ? errorMessage : 'Please contact your administrator')

      const errorMessageForm = error.response.data.errors
      if (errorMessageForm) {
        Object.keys(errorMessageForm).forEach((key) => {
          form.setFieldError(key, errorMessageForm[key][0])
        })
      }
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataMembership !== null) {
      handleSetForm(dataMembership)
    }
    // eslint-disable-next-line
  }, [dataMembership])

  const handleSetForm = (value) => {
    const data = {
      product_by_url: value.limit.product_by_url,
      product_by_url_limit: value.limit.product_by_url_limit,
      my_products: value.limit.my_products,
      my_products_limit: value.limit.my_products_limit,
    }
    form.initialize(data)
    form.setValues(data)
  }

  return (
    <Box>
      <Box mb='sm'>
        <Input.Wrapper
          size='xs'
          label="Limitation By URL"
        >
          <NumberInput
            size='xs'
            {...form.getInputProps('product_by_url')}
            min={0}
            mb='xs'
            disabled={form.getValues().product_by_url_limit}
          />
          <Switch
            size='xs'
            label="No Limitation"
            {...form.getInputProps('product_by_url_limit', { type: 'checkbox' })}
          />
        </Input.Wrapper>
      </Box>
      <Box mb='sm'>
        <Input.Wrapper
          size='xs'
          label="Limitation My Products"
        >
          <NumberInput
            size='xs'
            {...form.getInputProps('my_products')}
            min={0}
            mb='xs'
            disabled={form.getValues().my_products_limit}
          />
          <Switch
            size='xs'
            label="No Limitation"
            {...form.getInputProps('my_products_limit', { type: 'checkbox' })}
          />
        </Input.Wrapper>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={form.onSubmit((value) => submitLimitation(value))}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustMembership